import Vue from 'vue';
import { Icon, Image as VanImage, Loading, Swipe, SwipeItem, Tab, Tabbar, TabbarItem, Tabs } from 'vant';
import App from './App.vue';
import router from './router';
import store from './store';
import { initRem } from './utils/rem';
import './assets/styles/base.less';
import './assets/styles/common.less';

Vue.config.productionTip = false;
Vue.config.ignoredElements = [
  ...Vue.config.ignoredElements,
  'wx-open-launch-weapp'
];
Vue.use(Icon);
Vue.use(VanImage);
Vue.use(Loading);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Tab);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Tabs);

initRem();

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
